<template>
    <div class="row">
        <!-- E-mail -->
        <div class="col-md-6">
            <div class="form-group">
                <label for="userEmail">
                    <span class="required">*</span>
                    E-mail
                </label>
                <input
                    :disabled="disabledFields && disabledFields.email"
                    type="email"
                    class="form-control"
                    id="userEmail"
                    :value="value.email"
                    @input="updateField('email', $event.target.value)"
                    autocomplete="new-password"
                />
            </div>
        </div>

        <!-- Celular -->
        <div class="col-md-6">
            <div class="form-group">
                <label for="userCellphone">
                    <span class="required">*</span>
                    Celular
                </label>
                <input
                    type="text"
                    class="form-control"
                    id="userCellphone"
                    v-mask="'(##) #####-####'"
                    :value="value.cellphone"
                    @input="updateField('cellphone', $event.target.value)"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserContactInfo',
    props: {
        value: {
            type: Object,
            required: true
        },
        disabledFields: {
            type: Object,
            required: false,
            default: () => {}
        }
    },
    methods: {
        updateField(field, value) {
            this.$emit('update', field, value);
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/User/form-components/UserContactInfo.vue